import React from 'react';

import DataTable from '../Common/DataTable';
import Pagination from '../Common/Pagination'

import { NavLink } from 'react-router-dom';
import * as peopleApi from '../api/people';


const peopleColumnConfig = {
  
  name: {
    title: 'Name',
    isSortable: true,
    isSearchable: true,
    render: person => (
      <NavLink to={`/people/${person.id}`}>{person.name}</NavLink>
    ),
  },
  mass: {
    title: 'Mass',
    isSortable: true,
  },
  hair_color: {
    title: 'Hair Color',
  },
  skin_color: {
    title: 'Skin Color',
  },
  birth_year: {
    title: 'Born',
    isSortable: true,
  },
  gender: {
    title: 'Gender',
  },
  height: {
    title: 'Height',
  },
  species: {
    title: 'Species',
  },
  homeworld: {
    title: 'Homeworld ',
  },
  
};



class PeoplePage extends React.Component {
    state = {
      isLoaded: false,
      people: [],
      config: peopleColumnConfig,
      page: 0,
    };
  

    componentDidMount() {
      this.updatePageFromURL();
    }
  
    componentDidUpdate() {
      this.updatePageFromURL();
    }
  
    updatePageFromURL() {
      const { location } = this.props;
      const urlParams = new URLSearchParams(location.search);
      const page = +urlParams.get('page') || 1;
  
      if (page === this.state.page) {
        return;
      }
  
      this.setState({ page }, this.loadPeople);
    }
  
    loadPeople = async () => {
        const {page} = this.state;
        const { count, results: people} = await peopleApi.getAll({page});
    
          this.setState({
            people,
            count,
            isLoaded: true,
          });
    }
  
    render () {
      const { people, config, isLoaded, count, page  } = this.state;
  
      return (
        <div className="App">
          <h1>PeoplePage</h1>
          { isLoaded ? (
            <>
            <Pagination count={count} page={page} />
            <DataTable
              items={people}
              config={config}
            />
          </>) : (<h1>Loading...</h1>)}
        </div>
      );
    }
  }
  
  

export default PeoplePage;